import firebase from "./firebase";

const firestore = firebase.firestore();

export const getDetailInfo = async (id) =>
  await firestore
    .collection("articles")
    .doc(id)
    .get();
